import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "@/lib/data";

const LINES = ["Move Smarter.", "Pack by Color."];

export const Hero = () => (
  <section className="relative min-h-screen flex items-end overflow-hidden" data-testid="hero">
    <motion.div
      className="absolute inset-0"
      initial={{ scale: 1.15 }}
      animate={{ scale: 1 }}
      transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
    >
      <img src={IMAGES.hero} alt="Black moving totes with yellow lids stacked in a modern living room" className="h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-crate-black via-crate-black/60 to-crate-black/40" />
    </motion.div>

    <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-12 pb-20 md:pb-28 w-full">
      <motion.span
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="inline-block text-crate-yellow font-bold uppercase tracking-[0.25em] text-xs md:text-sm mb-6"
      >
        Reusable Moving Tote Rental · Iowa
      </motion.span>

      <h1 className="font-heading font-black text-white leading-[0.9] tracking-tighter text-6xl sm:text-7xl md:text-8xl lg:text-9xl">
        {LINES.map((line, li) => (
          <span key={li} className="block overflow-hidden">
            <motion.span
              className="block"
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ duration: 0.9, delay: 0.4 + li * 0.15, ease: [0.22, 1, 0.36, 1] }}
            >
              {li === 1 ? <span className="text-crate-yellow">{line}</span> : line}
            </motion.span>
          </span>
        ))}
      </h1>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        className="mt-8 max-w-xl text-lg md:text-xl text-white/70 leading-relaxed"
      >
        Skip the cardboard boxes. Rent durable, reusable moving totes delivered right to your door.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.15 }}
        className="mt-10 flex flex-col sm:flex-row gap-4"
      >
        <Link to="/reserve" data-testid="hero-reserve-btn" className="group inline-flex items-center justify-center gap-2 rounded-full bg-crate-yellow text-crate-black font-bold px-8 py-4 hover:bg-white transition-colors">
          Reserve Your Totes
          <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
        </Link>
        <Link to="/pricing" data-testid="hero-quote-btn" className="inline-flex items-center justify-center rounded-full border border-white/30 text-white font-bold px-8 py-4 hover:border-crate-yellow hover:text-crate-yellow transition-colors">
          Get a Quote
        </Link>
      </motion.div>
    </div>
  </section>
);
